import { render, staticRenderFns } from "./OnePrice.vue?vue&type=template&id=0fcdcef4&"
import script from "./OnePrice.vue?vue&type=script&lang=js&"
export * from "./OnePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports